import { useAuth0 } from '@auth0/auth0-react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    Alert,
    Box,
    Collapse,
    Grid,
    styled,
    Typography,
    FormControlLabel,
    Switch,
} from '@mui/material';
import { format } from 'date-fns';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addQuickBooking } from '../../redux/BookingSlice';
import { getSchoolTeachers } from '../../redux/SchoolSlice';
import GradeDropDown from '../CustomDropDown/GradeDropDown';
import TeacherMultiDropDown from '../CustomDropDown/TeacherMultiDropDown';
import TimeDropDown from '../CustomDropDown/TimeDropDown';

const BookingButton = styled(LoadingButton)(({ theme }) => ({
    padding: '10px 20px',
    margin: '10px auto',
    borderRadius: '30px',
}));

const QuickBook = props => {
    const { getAccessTokenSilently } = useAuth0();

    const [state, setState] = useState({
        open: false,
        grade: [],
        teachersInSchool: {
            value: [],
            error: '',
            errorCode: '',
        },
        startTime: '8:00 am',
        endTime: '4:00 pm',
        processingBooking: 0,
    });

    const [timeError, setTimeError] = useState(false);
    const [savedOnly, setSavedOnly] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        const startMoment = moment(state.startTime, 'h:mm a');
        const endMoment = moment(state.endTime, 'h:mm a');
        setTimeError(startMoment >= endMoment);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.startTime, state.endTime]);

    useEffect(() => {
        if (props.loadingAvails === false) {
            setState({
                ...state,
                processingBooking: 0,
                open: false,
                grade: [],
                teachersInSchool: {
                    value: [],
                    error: '',
                    errorCode: '',
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.loadingAvails]);

    useEffect(() => {
        if (props.school.getTeacherStatus === 'idle') {
            async function dispatchSchoolTeachersFromStore() {
                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });
                const requestData = {
                    'token': token,
                };

                //doesnt seem to work on Safari - need to troubleshoot
                dispatch(getSchoolTeachers(requestData));
            }
            dispatchSchoolTeachersFromStore();
        }
        console.log('school info', JSON.stringify(props.school));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.school.getTeacherStatus, props.school.teachersInSchool.Data]);

    const handleSelect = value => {
        console.log('value', value);
        var itemStruct = {
            value: value,
            touched: true,
        };
        setState({
            ...state,
            teachersInSchool: itemStruct,
        });
    };

    const handleGradeChange = value => {
        setState({
            ...state,
            grade: value,
        });
    };

    const handleStartTimeChange = event => {
        setState({
            ...state,
            startTime: event.target.value,
        });
    };

    const handleEndTimeChange = event => {
        setState({
            ...state,
            endTime: event.target.value,
        });
    };

    const handleQuickBookChange = event => {
        const checked = event.target.checked;
        props.onlyShowSaved(checked);
        setSavedOnly(checked);
    };

    const sendQuickBooking = async () => {
        try {
            setState({
                ...state,
                processingBooking: 4,
            });

            // props.notification({
            //     message: '',
            //     open: true,
            //     severity: 'success',
            // });
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            let requestData = {};

            const availIds = props.avails
                .filter(avail => !savedOnly || avail.saved)
                .map(avail => avail['gs1-pk']);

            if (props.school.teachersInSchool.Data.length === 0) {
                requestData = {
                    token: token,
                    request: {
                        sendToTeachers: availIds,
                        startTime: state.startTime,
                        endTime: state.endTime,
                        grade: state.grade,
                        date: format(props.date, 'yyyy-MM-dd'),
                        savedOnly: savedOnly,
                    },
                };
            } else {
                let fillInTeachers =
                    await props.school.teachersInSchool.Data.filter(
                        teacher =>
                            state.teachersInSchool.value.indexOf(teacher.pk1) >
                            -1
                    ).map(item => {
                        return {
                            pk1: item.pk1,
                            teacherFirstName: item.firstName,
                            teacherLastName: item.lastName,
                            profileImage: item.profileImage,
                        };
                    });
                requestData = {
                    token: token,
                    request: {
                        sendToTeachers: availIds,
                        teacherId: fillInTeachers,
                        startTime: state.startTime,
                        endTime: state.endTime,
                        grade: state.grade,
                        date: format(props.date, 'yyyy-MM-dd'),
                        savedOnly: savedOnly,
                    },
                };
            }
            const bookingOutcome = await dispatch(addQuickBooking(requestData));
            console.log('bookingoutcome', bookingOutcome);
            if (bookingOutcome.error !== undefined) {
                if (
                    bookingOutcome.error?.message ===
                    'Request failed with status code 402'
                ) {
                    setState({
                        ...state,
                        processingBooking: 3,
                        apiMessage:
                            'Monthly booking allocation depleaded. Change subscription to allow unlimited bookings.',
                    });
                } else {
                    setState({
                        ...state,
                        processingBooking: 3,
                        apiMessage:
                            'There was an error when trying to send out the quick booking request to all recipients. Please try again later.',
                    });
                }
            } else {
                setState({
                    ...state,
                    processingBooking: 1,
                });
                props.quickBookComplete(true);
            }
        } catch (err) {
            console.log('Error occurred adding booking', err);

            setState({
                ...state,
                processingBooking: 3,
                apiMessage:
                    'There was an error when trying to send out the quick booking request to all recipients. Please try again later.',
            });

            // props.notification({
            //     message: 'Creating the Booking Failed',
            //     open: true,
            //     severity: 'error',
            // });
        }
    };

    return (
        <Box>
            {/* Handle error below where 402 shows that the user has used all their credit */}
            {state.processingBooking === 3 ? (
                <Box>
                    <Alert severity="error">{state.apiMessage}</Alert>
                </Box>
            ) : (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {state.processingBooking === 1 ? (
                        <Box>
                            <Alert severity="success">
                                Booking has been sent to all recipients.
                            </Alert>
                        </Box>
                    ) : (
                        <Grid
                            xs={12}
                            md={8}
                            sx={{
                                borderRadius: state.open ? '5px' : '0px',
                                boxShadow: state.open
                                    ? '1px 1px 9px -2px rgb(0 0 0 / 40%)'
                                    : '0px',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <BookingButton
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        setState({
                                            ...state,
                                            open: !state.open,
                                        });
                                    }}
                                    endIcon={
                                        state.open ? (
                                            <KeyboardArrowUpIcon />
                                        ) : (
                                            <KeyboardArrowDownIcon />
                                        )
                                    }
                                >
                                    Quick Book
                                </BookingButton>
                            </Box>

                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <Typography
                                    variant="body2"
                                    maxWidth={350}
                                    align="center"
                                >
                                    The Quick Book function allows you to send
                                    the booking request to all teachers in your
                                    area
                                </Typography>
                            </Box>

                            <Collapse in={state.open} timeout={1000}>
                                <Box>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <TimeDropDown
                                                id="startTime"
                                                title="Start Time"
                                                defaultTime={state.startTime}
                                                handleTimeChange={
                                                    handleStartTimeChange
                                                }
                                                center
                                                error={timeError}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TimeDropDown
                                                id="endTime"
                                                title="End Time"
                                                defaultTime={state.endTime}
                                                handleTimeChange={
                                                    handleEndTimeChange
                                                }
                                                center
                                                error={timeError}
                                                errorText={'Times are invlalid'}
                                            />
                                        </Grid>
                                    </Grid>
                                    <GradeDropDown
                                        title="Grade"
                                        subtitle="Select grade level"
                                        grade={state.grade}
                                        schoolGrades={[
                                            'PrimarySchool',
                                            'Kindergarten',
                                            'SecondarySchool',
                                            'FoundationPrep',
                                        ]}
                                        handleGrade={handleGradeChange}
                                        center
                                    />
                                    {typeof props.school.teachersInSchool
                                        .Data === 'undefined' ? (
                                        <div></div>
                                    ) : (
                                        <TeacherMultiDropDown
                                            id="teacherInSchool"
                                            selectedTeachers={
                                                state.teachersInSchool.value
                                            }
                                            teachers={
                                                props.school.teachersInSchool
                                                    .Data
                                            }
                                            handleSelect={handleSelect}
                                            subtitle="Select Replacement Teacher"
                                            title="Classroom Teacher (OPTIONAL):"
                                            compareValue="pk1"
                                            loadingStatus={
                                                props.school.getTeacherStatus
                                            }
                                            center
                                        />
                                    )}

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Grid container align="center">
                                            <Grid item xs={12}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            onChange={
                                                                handleQuickBookChange
                                                            }
                                                        />
                                                    }
                                                    label="Send to saved teachers only"
                                                />
                                            </Grid>
                                            <BookingButton
                                                variant="contained"
                                                color="primary"
                                                onClick={sendQuickBooking}
                                                loading={
                                                    state.processingBooking ===
                                                    4
                                                }
                                                disabled={
                                                    timeError ||
                                                    props.avails.filter(
                                                        avail =>
                                                            !savedOnly ||
                                                            avail.saved
                                                    ).length === 0
                                                }
                                            >
                                                Send quick booking request
                                            </BookingButton>
                                        </Grid>
                                    </Box>
                                </Box>
                            </Collapse>
                        </Grid>
                    )}
                </Box>
            )}
        </Box>
    );
};
export default QuickBook;
